import {Box} from 'src/design/atoms/Box';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {Button} from 'src/design/atoms/Button';
import {Title} from 'src/design/atoms/Title';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {routeRegistry} from 'src/pages/RouteRegistry';

const documentTitle = 'Risk Assessment Code Not Found';

const RiskAssessmentCodeMissingPage = () => {
  useSetDocumentTitle(documentTitle);

  return (
    <Stack mt="md" gap="md">
      <Title>Risk Assessment Code Not Found</Title>
      <Text>
        It looks like you are trying to access a module that requires a risk
        assessment code to be configured for your system, but we are not able to
        find it. Please contact your administrator for support in creating a
        risk assessment code.
      </Text>
      <Box>
        <Button
          aria-label="backToHomeBtnUI"
          onClick={() => window.location.assign(PathUtility.Dashboard())}>
          Back to Home
        </Button>
      </Box>
    </Stack>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.RiskAssessmentMissing(),
  element: <RiskAssessmentCodeMissingPage />,
  isPrivate: false,
});

export default RiskAssessmentCodeMissingPage;
